import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiHome, FiGrid, FiShoppingCart, FiHeart, FiUser, FiPhone } from 'react-icons/fi';
import { useCart } from '../../context/CartContext';
import { useWishlist } from '../../context/WishlistContext';
import { useAuth } from '../../context/AuthContext';
import './BottomNav.css';

function BottomNav() {
  const location = useLocation();
  const { cart = { itemCount: 0 } } = useCart();
  const { wishlistCount } = useWishlist();
  const { isAuthenticated } = useAuth();

  const tabs = [
    { path: '/', label: 'Home', icon: <FiHome size={20} />, exact: true },
    { path: '/shop', label: 'Shop', icon: <FiGrid size={20} /> },
    { path: '/cart', label: 'Cart', icon: <FiShoppingCart size={20} />, badge: cart?.itemCount || 0 },
    { path: '/wishlist', label: 'Wishlist', icon: <FiHeart size={20} />, badge: wishlistCount || 0 },
    { path: isAuthenticated ? '/dashboard' : '/login', label: isAuthenticated ? 'Account' : 'Login', icon: <FiUser size={20} /> },
  ];

  const isActive = (tab) => {
    if (tab.exact) return location.pathname === tab.path;
    return location.pathname.startsWith(tab.path);
  };

  return (
    <nav className="bottom-nav">
      {tabs.map((tab) => (
        <Link
          key={tab.path}
          to={tab.path}
          className={`bottom-nav-item ${isActive(tab) ? 'active' : ''}`}
        >
          <div className="bottom-nav-icon">
            {tab.icon}
            {tab.badge > 0 && <span className="bottom-nav-badge">{tab.badge}</span>}
          </div>
          <span className="bottom-nav-label">{tab.label}</span>
        </Link>
      ))}
    </nav>
  );
}

export default BottomNav;
